<div class="create-survey-wrapper w-full hidden sm:flex sm:flex-col">
  <div class="title-wrapper w-[100%]">
    <div class="title-section">
      <div class="title-content">
        {{surveyDetails?.title}}
      </div>
      <div class="description-content">
        {{surveyDetails?.description}}
      </div>
      <div *ngIf="!(surveyDetails?.status?.key === surveyStatusMap.closed) && loggedInUserRole ===
       1 && (!groupId && !clientId)"
           class="w-full close-button-section">
        <app-primary-button (handleClick)="closeSurveyButtonClicked()"
                            class="w-[50%] md:w-[20%]"
                            type="small">Close Survey
        </app-primary-button>
      </div>
    </div>
  </div>
  <div class="form-wrapper w-full">
    <div class="w-full">
      <div
        *ngIf="!(surveyDetails?.status?.key === surveyStatusMap?.closed) && surveyDetails?.respondentsCount > 0 && (!groupId && !clientId)"
        class="description-content">
        Disclaimer: This can't be modified as it has active responses from users
      </div>
      <div class="flex w-full justify-start more-filter-content"> Schedule</div>
      <hr class="w-full separator">
      <div
        class="general-information-description-input-section w-full sm:w-[98%] flex-col sm:flex-row flex justify-center">
        <div class="w-full sm:w-[90%] flex flex-col sm:flex-row justify-center">
          <div class="w-full flex flex-col justify-between md:flex-row">
            <div class="schedule-input-section w-full md:w-[45%] ">
              <app-filter-dropdown
                (checkForErrors)="checkForErrors($event)"
                [enableClearSelection]="true"
                [error]="errorMessages['scheduleAccordingTo']"
                [loading]="scheduleAccordingToLoading"
                [options]="scheduleAccordingToOptions"
                [parentFormGroup]="form"
                controlName="scheduleAccordingTo"
                label="Schedule According to"
                placeholder="Select one"
                type="small"></app-filter-dropdown>
            </div>
            <div *ngIf="form?.value?.scheduleAccordingTo === scheduleAccordingToMap?.session"
                 class="schedule-input-section w-full md:w-[50%]">
              <app-filter-dropdown
                (checkForErrors)="checkForErrors($event)"
                [enableClearSelection]="true"
                [error]="errorMessages['session']"
                [loading]="sessionLoading"
                [options]="sessionDropDownOptions"
                [parentFormGroup]="form"
                controlName="session"
                label="Session"
                placeholder="Select one"
                type="small"></app-filter-dropdown>
            </div>
            <div *ngIf="form?.value?.scheduleAccordingTo === scheduleAccordingToMap?.custom"
                 class="general-information-input-section w-full md:w-[50%] flex-col md:flex-row flex justify-between">
              <div class="w-full md:w-[48%]">
                <app-date-picker
                  (checkForErrors)="checkForErrors($event)"
                  [error]="errorMessages['activeFrom']"
                  [min]="todaysDate"
                  [parentFormGroup]="form"
                  controlName="activeFrom"
                  label="From"
                  placeholder="From"
                  type="small"></app-date-picker>
              </div>
              <div class="w-full md:w-[48%]">
                <app-date-picker
                  (checkForErrors)="checkForErrors($event)"
                  [enableAllSelection]="true"
                  [error]="errorMessages['activeTo']"
                  [min]="form.controls['activeFrom'].value?
                  form.controls['activeFrom'].value: todaysDate"
                  [parentFormGroup]="form"
                  controlName="activeTo"
                  label="To"
                  placeholder="To"
                  type="small"></app-date-picker>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="general-information-content mt-[2rem]"> Send to</div>
      <hr class="w-full separator">
      <div class="general-information-form-wrapper w-full flex flex-col items-center">
        <div class="general-information-input-section w-full sm:w-[90%]">
          <app-filter-dropdown
            (checkForErrors)="checkForErrors($event)"
            [enableAllSelection]="true"
            [enableClearSelection]="true"
            [enableMultiple]="true"
            [error]="errorMessages['roles']"
            [loading]="rolesLoading"
            [options]="rolesOptions"
            [parentFormGroup]="form"
            controlName="roles"
            label="Choose Roles"
            placeholder="Select all that apply"
            type="small"></app-filter-dropdown>
        </div>
        <div
          class="general-information-description-input-section w-full sm:w-[90%] flex-col sm:flex-row flex justify-between">
          <div *ngIf="loggedInUserRole === roleMap?.superAdmin && !onlySuperAdminSelected"
               class="w-full sm:w-[48%]">
            <app-filter-dropdown
              (checkForErrors)="checkForErrors($event)"
              (onNextPage)="fetchClinicsNextPageOptions()"
              [enableAllSelection]="true"
              [enableClearSelection]="true"
              [enableMultiple]="true"
              [enableSearch]="true"
              [error]="errorMessages['clientIds']"
              [filterControlName]="'clientSearch'"
              [hasNext]="clinicsHasNext"
              [loading]="clinicsLoading"
              [options]="clinicsOptions"
              [parentFormGroup]="form"
              [searchPlaceholder]="'Search'"
              controlName="clientIds"
              label="Choose Organizations"
              placeholder="Select all that apply"
              type="small"></app-filter-dropdown>
          </div>
          <div *ngIf="loggedInUserRole === roleMap?.superAdmin && !onlySuperAdminSelected"
               class="w-full sm:w-[48%]">
            <app-filter-dropdown
              (checkForErrors)="checkForErrors($event)"
              (onNextPage)="fetchGroupsNextPageOptions()"
              [enableAllSelection]="true"
              [enableClearSelection]="true"
              [enableMultiple]="true"
              [enableSearch]="true"
              [error]="errorMessages['groupIds']"
              [filterControlName]="'groupSearch'"
              [hasNext]="groupHasNext"
              [loading]="groupsLoading"
              [options]="groupsOptions"
              [parentFormGroup]="form"
              [searchPlaceholder]="'Search'"
              controlName="groupIds"
              label="Choose Groups"
              placeholder="Select all that apply"
              type="small"></app-filter-dropdown>
          </div>
        </div>
        <div class="flex w-full justify-start more-filter-content"> More
          Filters
        </div>
        <hr class="w-full separator">
        <div
          class="general-information-description-input-section w-full sm:w-[90%] flex-col sm:flex-row flex justify-between">
          <div *ngIf="!onlySuperAdminSelected"
               class="w-full sm:w-[48%]">
            <app-filter-dropdown
              (checkForErrors)="checkForErrors($event)"
              [enableAllSelection]="true"
              [enableClearSelection]="true"
              [enableMultiple]="true"
              [error]="errorMessages['groupStatus']"
              [loading]="groupStatusLoading"
              [options]="groupStatusOptions"
              [parentFormGroup]="form"
              controlName="groupStatus"
              label="Group Status"
              placeholder="Select all that apply"
              type="small"></app-filter-dropdown>
          </div>
          <div class="w-full sm:w-[48%]">
            <app-filter-dropdown
              (checkForErrors)="checkForErrors($event)"
              [enableAllSelection]="true"
              [enableClearSelection]="true"
              [enableMultiple]="true"
              [error]="errorMessages['gender']"
              [loading]="genderLoading"
              [options]="genderOptions"
              [parentFormGroup]="form"
              controlName="gender"
              label="Choose Gender"
              placeholder="Select all that apply"
              type="small"></app-filter-dropdown>
          </div>
        </div>
      </div>
    </div>
    <hr class="w-full separator">
    <div class="schedule-form-wrapper w-full flex justify-center">
      <div *ngIf="!(surveyDetails?.status?.key === surveyStatusMap?.closed) &&
                            !(surveyDetails?.respondentsCount >0) &&
                             !groupId && !clientId"
           class="w-full sm:w-[90%] flex justify-end">
        <app-primary-button (handleClick)="saveButtonClicked()"
                            class="w-full md:w-[30%] lg:w-[20%]"
                            type="small">
          <div
            class="add-user flex flex-row justify-center items-center space-x-[1rem]">
            Save
          </div>
        </app-primary-button>
      </div>
    </div>
  </div>
</div>
<div class="flex sm:hidden">
  <app-screen-size-alert
    [hyperLinkText]="'Go Back To Manage Questionnaires'"
    navigationLink="/stanford-admin/questionnaires/manage-questionnaires">
  </app-screen-size-alert>
</div>
